









































import { Component, Prop, Vue } from 'vue-property-decorator';
import {GlossaryTerm, GlossaryType} from '@/models/GlossaryTerm';
import { isSubString } from '@/utils/strings';
import GlossaryData from '@/glossary.json';

import store from '@/store';
import { AppModule } from '@/store/modules/app';
import { getModule } from 'vuex-module-decorators';
import { BTBA, OpenGlossaryTermProperties, SearchGlossaryTermProperties} from '@/analytics/events/BTBA';
import btbConf from '@/btb-conf.json'
import axios from 'axios';
import BTB_CONF from '@/btb-conf.json';
import { BtbConf } from '@/types/BtbConf';

const AppState = getModule(AppModule, store);

@Component
export default class Glossary extends Vue {
  thresholdPercentageToChooseGlossary: number = 80;
  showTerm: boolean = false;
  query: string = '';
  searchInputValue: string = '';
  glossaryData: GlossaryType = GlossaryData;
  terms: GlossaryTerm[] = this.glossaryData.glossary.sort(this.sortGlossary);
  currentTermElement!: HTMLElement;
  BTB_CONF: BtbConf = BTB_CONF;
  @Prop(Boolean) lightmode: boolean = false;
  searchTimeout : any;
  public $refs!: {
    listOfTerms: HTMLFormElement;
    detailsTitle: HTMLFormElement;
    searchInput: HTMLFormElement;
  };

  currentTerm: GlossaryTerm = {
    term: '',
    definition: ''
  };

  mounted(){
    this.fetchGlossary()
  }

  async fetchGlossary(){
    if (this.glossaryData.mode && this.glossaryData.mode === 'replace') return

    try {
      this.terms = await this.getGlossary()
      this.mergeGlossary()
      this.terms.sort(this.sortGlossary)
    }catch(e){
      this.terms = this.glossaryData.glossary.sort(this.sortGlossary);
      if (this.BTB_CONF.debug) {
        console.log('=== LOG ===');
        console.log('Call to external glossary URL failed')
        console.log(`It was tried to be fetched on: ${this.getGlossaryUrl()}`)
        console.log(`For the language: ${btbConf.courseInfo.localization}`)
      }
    }

  }

  private async getGlossary(): Promise<GlossaryTerm[]>{
    const request = await axios.get(this.getGlossaryUrl());
    
    const externalGlossary: GlossaryTerm[] = request.data.glossary;
    const localGlossary: GlossaryTerm[] = this.glossaryData.glossary;

    const externalGlossaryFilter = externalGlossary.filter(this.cleanEmptyEntries);
    const localGlossaryFilter = localGlossary.filter(this.cleanEmptyEntries);

    const percentageCompare = externalGlossaryFilter.length * 100 / localGlossaryFilter.length;
    const abbleToChooseExternal = percentageCompare > this.thresholdPercentageToChooseGlossary;
    
    if(abbleToChooseExternal){
      return externalGlossary;
    }

    if (this.BTB_CONF.debug) {
      console.log('=== LOG ===');
      console.log('Invalid external glossary:');

      if(!abbleToChooseExternal) {
        console.log(`External file only has ${percentageCompare.toFixed(2)}% of trusted content!`);
      }
    }
    
    return localGlossary;
  }

  private cleanEmptyEntries(item: GlossaryTerm){
      return item.term!=="" && item.definition.trim()!=="" && item
  }

  mergeGlossary(){
    if (this.glossaryData.mode !== 'merge') return
    if (!this.glossaryData.mergeTerms) return
    
    this.terms = this.terms.concat(this.glossaryData.mergeTerms)
  }

  getGlossaryUrl() {
    var lang = btbConf.courseInfo.localization
    var staticPath = process.env.VUE_APP_GLOSSARY_URL;
    return `${staticPath}glossary.${lang}.json`
  }

  get filteredGlossary() {
    if (!this.terms) return [];

    return this.terms.filter(
      term =>
        isSubString(term.term, this.query) ||
        isSubString(term.definition, this.query)
    );
  }

  private onSearchInput() {
    // If the term detail panel is open and the user begins typing,
    // we want to close the term detail panel and go back to the list of terms
    if (this.showTerm) {
      this.closeTerm();
    }

    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(()=>{
      // Wait for typing pauses
      if(this.query.length > 2){ // Adding a filter to avoid meaningless searches to be tracked.
        this.$analytics.trackEvent(BTBA.searchGlossary,{
          'Glossary Query' : this.query,
          'Page ID' : AppState.getCurrentSlide,
          'Page Title': AppState.getCurrentSlideTitle,
        } as SearchGlossaryTermProperties)
      }
    }, 800)
  }

  private openTerm(term: GlossaryTerm, e:any) {
    this.currentTerm = term;
    this.currentTermElement = e.target
    this.showTerm = true;
    setTimeout(() => {
      this.$refs.detailsTitle.focus({ preventScroll: true });
    }, 500);
    this.$analytics.trackEvent(BTBA.openGlossaryTerm,{
      'Glossary Term' : this.currentTerm.term,
      'Page ID' : AppState.getCurrentSlide,
      'Page Title': AppState.getCurrentSlideTitle,
    } as OpenGlossaryTermProperties)
  }

  private closeTerm() {
    const { searchInput, listOfTerms } = this.$refs;
    this.showTerm = false;
    setTimeout(() => {
      let isElementAButton = this.currentTermElement.getAttribute("role") == "button"
      if(isElementAButton){
        this.currentTermElement.focus()
      }else{
        let parent = this.currentTermElement.parentElement
        if(parent)
          parent.focus();
      }
    }, 500);
  }

  sortGlossary(a:GlossaryTerm,b:GlossaryTerm){
    const termA = a.term.toUpperCase();
    const termB = b.term.toUpperCase();
    let comparison = 0;
    if (termA > termB) {
      comparison = 1;
    } else if (termA < termB) {
      comparison = -1;
    }
    return comparison;
  }

  public submit(){
    this.query = this.searchInputValue;
  }
}
